import { c as _c } from "react/compiler-runtime";
import { PricePlanId, PricePlanType } from '@systemeio/types';
import { PRICE_PLANS_API } from 'modules/digital-product/price-plans/api/price-plans-api';
import { PricePlanCreateApiInterface, PricePlanEditInterface } from 'modules/digital-product/price-plans/types/price-plan-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
export const usePricePlansApi = () => {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: postFetcher
  } = useFetch(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.put
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fetcher: putFetcher
  } = useFetch(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.delete
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    fetcher: deleteFetcher
  } = useFetch(t2);
  let t3;
  if ($[3] !== postFetcher) {
    t3 = data => postFetcher(`${PRICE_PLANS_API}/create`, data);
    $[3] = postFetcher;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== putFetcher) {
    t4 = (id, data_0) => putFetcher(`${PRICE_PLANS_API}/${id}`, data_0);
    $[5] = putFetcher;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== deleteFetcher) {
    t5 = id_0 => deleteFetcher(`${PRICE_PLANS_API}/${id_0}`);
    $[7] = deleteFetcher;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = {
      createPricePlan: t3,
      updatePricePlan: t4,
      deletePricePlan: t5
    };
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};